import { render } from "./dl-intro.vue?vue&type=template&id=d28c06fa"
import script from "./dl-intro.vue?vue&type=script&lang=js"
export * from "./dl-intro.vue?vue&type=script&lang=js"

import "./dl-intro.vue?vue&type=style&index=0&id=d28c06fa&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__